import type {CooldownStatus} from "@khan/guide-types";

import type {CooldownStatusResponse} from "../queries/use-fetch-cooldown-status.ts";

/**
 * Threshold indicating low quota.
 *
 * This is a value between 0 and 1.
 */
export const LOW_QUOTA_THRESHOLD = 0.1;

/**
 * HTTP status code for Too Many Requests.
 */
export const STATUS_TOO_MANY_REQUESTS = 429;

/**
 * HTTP status code for Forbidden.
 */
export const STATUS_FORBIDDEN = 403;

/**
 * HTTP status code for Bad Request.
 */
export const STATUS_BAD_REQUEST = 400;

/**
 * Error code for internal errors.
 */
export const ERROR_CODE_INTERNAL = "internal";

/**
 * Error code for quota exceeded.
 */
export const ERROR_CODE_QUOTA_EXCEEDED = "quota_exceeded";

/**
 * Error code for rate limited.
 */
export const ERROR_CODE_RATE_LIMITED = "rate_limited";

/**
 * Error code for invalid input.
 */
export const ERROR_CODE_INVALID_INPUT = "invalid_input";

/**
 * Default cooldown status when no cooldown is active.
 * Stable fallback object to prevent infinite re-renders.
 */
export const DEFAULT_COOLDOWN_STATUS: CooldownStatus = {
    hasCooldown: false,
    cooldownType: "None",
    expiresAt: null,
    teacherKaid: null,
    teacherName: null,
} as const;

/**
 * Default cooldown response for non-success states.
 * Stable fallback object to prevent infinite re-renders.
 */
export const DEFAULT_COOLDOWN_RESPONSE_NON_SUCCESS: CooldownStatusResponse = {
    status: "no-data", // This will be overridden with the actual status
    hasCooldown: false,
    cooldownStatus: DEFAULT_COOLDOWN_STATUS,
} as const;
